import { EcCountry } from './country';
import { EbCompagnie } from "../classes/compagnie";
import { EbAdresse } from "./adresse";
import { EbCostCenter } from "./costCenter";
import { EbCategorie } from './categorie';
import { EbUser } from './user';
import { TypeFlux } from '../utils/enumeration';
import { ebEtablissement } from './etablisssement';
import { EbEtablissementAgence } from './EbEtablissementAgence';
import { ModeTransport } from './modeTransport';

export class EbEtablissement {
    ebEtablissementNum: number;
    siret: string;
    nic: string;
    nom: string;
    adresse: string;
    telephone: string;
    email: string;
    siteWeb: string;
    logo: string;
    ebCompagnie: EbCompagnie;
    listAdresses: Array<EbAdresse>;
    costCenters: Array<EbCostCenter>;
    categories: Array<EbCategorie>;
    city: string;
    ecCountry: EcCountry;
    nmbrUtilisateurs: number;
    service: number;
    code: String;
    modeTransport: ModeTransport;
    listModeTransport: String;
    listAgences : Array<EbEtablissementAgence>;

    constructor() {
        this.ebEtablissementNum = null;
        this.siret = null;
        this.nom = null;
        this.adresse = null;
        this.telephone = null;
        this.email = null;
        this.siteWeb = null;
        this.logo = null;
        this.ebCompagnie = new EbCompagnie();
        this.listAdresses = new Array<EbAdresse>();
        this.ecCountry = null;
        this.costCenters = new Array<EbCostCenter>();
        this.nmbrUtilisateurs = null;
        this.service = null;
        this.categories = new Array<EbCategorie>();
        this.city = null;
        this.nic = null;
        this.code = null;
        this.modeTransport = new ModeTransport();
        this.listModeTransport = null;
        //this.listUsers = new Array<EbUser>();
        this.listAgences = new Array<EbEtablissementAgence>();
    }

    constructorCopy(ebEtablissement: EbEtablissement) {
        this.constructor();
        this.ebEtablissementNum = ebEtablissement.ebEtablissementNum;
        this.siret = ebEtablissement.siret;
        this.nom = ebEtablissement.nom;
        this.adresse = ebEtablissement.adresse;
        this.telephone = ebEtablissement.telephone;
        this.email = ebEtablissement.email;
        this.siteWeb = ebEtablissement.siteWeb;
        this.logo = ebEtablissement.logo;
        this.ebCompagnie = ebEtablissement.ebCompagnie;
        this.listAdresseCopy(ebEtablissement.listAdresses);
        this.ecCountry = ebEtablissement.ecCountry;
        this.costCentersCopy(ebEtablissement.costCenters);
        this.nmbrUtilisateurs = ebEtablissement.nmbrUtilisateurs;
        this.service = ebEtablissement.service;
        this.categorieCopy(ebEtablissement.categories);
        this.city = ebEtablissement.city;
        this.nic = ebEtablissement.nic;
        this.code = ebEtablissement.code;
        this.modeTransport = JSON.parse(JSON.stringify(ebEtablissement.modeTransport));
        if(this.modeTransport == null) {
            this.modeTransport = new ModeTransport();
        }
        this.listModeTransport = ebEtablissement.listModeTransport;

        // this.listUsersCopy(ebEtablissement.listUsers);
    }

    constructorCopyLite(ebEtablissement: EbEtablissement) {
        this.constructor();
        this.ebEtablissementNum = ebEtablissement.ebEtablissementNum;
    }

    listAdresseCopy(listAdresses: Array<EbAdresse>) {
        let _adresse;
        if (listAdresses !== undefined && listAdresses !== null && listAdresses.length !== 0) {
            for (let adresse of listAdresses) {
                _adresse = new EbAdresse();
                _adresse.constructorCopy(adresse);
                this.listAdresses.push(_adresse);
            }
        }
        else {
            this.listAdresses = new Array<EbAdresse>();
            // this.adresses.push(new Adresse());
            // push only when necessary in your component
        }
    }

    costCentersCopy(costCenters: Array<EbCostCenter>) {
        let _costCenter;
        if (costCenters !== undefined && costCenters !== null && costCenters.length !== 0) {
            for (let costCenter of costCenters) {
                _costCenter = new EbCostCenter();
                _costCenter.constructorCopy(costCenter);
                this.costCenters.push(_costCenter);
            }
        }
        else {
            this.costCenters = new Array<EbCostCenter>();
        }
    }

    categorieCopy(categories: Array<EbCategorie>) {
        let _categorie;
        if (categories !== undefined && categories !== null && categories.length !== 0) {
            for (let categorie of categories) {
                _categorie = new EbCategorie();
                _categorie.constructorCopy(categorie);
                this.categories.push(_categorie);
            }
        }
        else {
            this.categories = new Array<EbCategorie>();
        }
    }
    /*
    listUsersCopy(listUsers: Array<EbUser>) {
        let _user;
        if (listUsers !== undefined && listUsers !== null && listUsers.length !== 0) {
            for (let user of listUsers) {
                _user = new EbUser();
                _user.constructorCopy(user);
                console.log(_user);
                this.listUsers.push(_user);
            }
        }
        else {
            this.listUsers = new Array<EbUser>();
        }
    }*/
}



// WEBPACK FOOTER //
// ./src/app/classes/etablissement.ts